import { css } from 'aphrodite';
import * as React from 'react';
import { toast } from 'sonner';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { ExportIcon } from '../../../../web/components/svgs/icons/ExportIcon';
import { TransparentButton } from '../../../components/TransparentButton';
import { ILeadViewFilter } from '../../../entities/LeadView/useLeadView';
import { useExportTranscripts } from '../../../entities/PhoneCall/useExportTranscripts';
import { styleSheet } from '../styles';

interface ILeadViewFilterProps {
	filter?: ILeadViewFilter;
}

export const ExportReport: React.FC<ILeadViewFilterProps> = ({ filter }) => {
	const { bulkExport } = useExportTranscripts();

	const [showSpinner, setSpinner] = React.useState(false);

	return (
		<TransparentButton
			className={css(styleSheet.exportReportButton)}
			onClick={() => {
				setSpinner(true);

				bulkExport(filter).then(result => {
					setSpinner(false);

					if (result?.success) {
						toast.success('You will receive an email when your export is ready to be downloaded.');
					} else {
						toast.error(result?.systemMessage);
					}
				});
			}}
		>
			{showSpinner ? <LoadingSpinner type='extra-small' /> : <ExportIcon />} Export Report
		</TransparentButton>
	);
};
